function hasValue(value) {
  return value !== null && value !== undefined && value !== '';
}

function rangeText(label, from, to, unit = '') {
  if (hasValue(from) && hasValue(to) && String(from) === String(to)) return `${label} ${from}${unit}`;
  if (hasValue(from) && hasValue(to)) return `${label} ${from}-${to}${unit}`;
  if (hasValue(from)) return `${label} от ${from}${unit}`;
  if (hasValue(to)) return `${label} до ${to}${unit}`;
  return null;
}

export function getActiveFilterChips(filters) {
  const chips = [];
  const year = rangeText('Год', filters.yearFrom, filters.yearTo);
  const value = rangeText('USD', filters.valueMin, filters.valueMax);
  const weight = rangeText('Вес', filters.weightMin, filters.weightMax, ' кг');

  if (year) chips.push({ key: 'year', label: year });
  if (hasValue(filters.country)) chips.push({ key: 'country', label: `Страна ${filters.country}` });
  if (hasValue(filters.tradingCountry)) chips.push({ key: 'tradingCountry', label: `Торг. страна ${filters.tradingCountry}` });
  if (value) chips.push({ key: 'value', label: value });
  if (weight) chips.push({ key: 'weight', label: weight });
  if (hasValue(filters.trademark)) chips.push({ key: 'trademark', label: `Марка ${filters.trademark}` });
  if (hasValue(filters.importer)) chips.push({ key: 'importer', label: `Импортёр ${filters.importer}` });
  if (hasValue(filters.exporter)) chips.push({ key: 'exporter', label: `Экспортёр ${filters.exporter}` });
  if (hasValue(filters.productCodePrefix)) chips.push({ key: 'productCodePrefix', label: `Код ${filters.productCodePrefix}` });

  return chips;
}

export function filterSignature(filters) {
  const normalized = {};
  Object.keys(filters || {}).sort().forEach(key => {
    const value = filters[key];
    if (hasValue(value)) normalized[key] = String(value).trim();
  });
  return JSON.stringify(normalized);
}
